import clsx from "clsx";
import React from "react";

import AccountIconSvg from "img/icons/account-icon.svg?inline";
import AppleIconSvg from "img/icons/apple-icon.svg?inline";
import ArrowDownSvg from "img/icons/arrow-down.svg?inline";
import ArrowEmoSvg from "img/icons/arrow-emo.svg?inline";
import ArrowIconSvg from "img/icons/arrow-icon.svg?inline";
import ArrowLeftSvg from "img/icons/arrow-left.svg?inline";
import ArrowRightSvg from "img/icons/arrow-right.svg?inline";
import BasketIconSvg from "img/icons/basket-icon.svg?inline";
import BellEmptySvg from "img/icons/bell-empty.svg?inline";
import BellNavFilledSvg from "img/icons/bell-nav-filled.svg?inline";
import BellNavSvg from "img/icons/bell-nav.svg?inline";
import BellSvg from "img/icons/bell.svg?inline";
import CalendarSvg from "img/icons/calendar.svg?inline";
import ChevronEmoSvg from "img/icons/chevron-emo.svg?inline";
import ChevronMediumSvg from "img/icons/chevron-medium.svg?inline";
import ChevronThinSvg from "img/icons/chevron-thin.svg?inline";
import ChevronSvg from "img/icons/chevron.svg?inline";
import ClearFilledSvg from "img/icons/clear-filled.svg?inline";
import ClearSvg from "img/icons/clear.svg?inline";
import CloseSharpSvg from "img/icons/close-sharp.svg?inline";
import CloseSvg from "img/icons/close.svg?inline";
import CopySvg from "img/icons/copy.svg?inline";
import CrossThinSvg from "img/icons/cross-thin.svg?inline";
import CrossSvg from "img/icons/cross.svg?inline";
import DeliveredFilledSvg from "img/icons/delivered-filled.svg?inline";
import EmoBasketSvg from "img/icons/emo-basket.svg?inline";
import EmoStarSvg from "img/icons/emo-star.svg?inline";
import EmoTickSvg from "img/icons/emo-tick.svg?inline";
import ErrorCircleSvg from "img/icons/error-circle.svg?inline";
import ErrorFilledSvg from "img/icons/error-filled.svg?inline";
import ErrorSvg from "img/icons/error.svg?inline";
import ExpandLegacySvg from "img/icons/expand-legacy.svg?inline";
import ExpandSvg from "img/icons/expand.svg?inline";
import ExternalLinkSvg from "img/icons/external-link.svg?inline";
import FacebookIconSvg from "img/icons/facebook-icon.svg?inline";
import FacebookSvg from "img/icons/facebook.svg?inline";
import FiltersSvg from "img/icons/filters.svg?inline";
import GoogleIconSvg from "img/icons/google-icon.svg?inline";
import HeartBrokenSvg from "img/icons/heart-broken.svg?inline";
import HeartEmptySvg from "img/icons/heart-empty.svg?inline";
import HeartIconEmptySvg from "img/icons/heart-icon-empty.svg?inline";
import HeartIconFilledSvg from "img/icons/heart-icon-filled.svg?inline";
import HeartIconNavFilledSvg from "img/icons/heart-icon-nav-filled.svg?inline";
import HeartIconNavSvg from "img/icons/heart-icon-nav.svg?inline";
import HeartPressedSvg from "img/icons/heart-pressed.svg?inline";
import HeartUnpressedSvg from "img/icons/heart-unpressed.svg?inline";
import HeartSvg from "img/icons/heart.svg?inline";
import HyperlinkSvg from "img/icons/hyperlink.svg?inline";
import IconSmileySvg from "img/icons/icon-smiley.svg?inline";
import InfoCircleSvg from "img/icons/info-circle.svg?inline";
import InfoIconSvg from "img/icons/info-icon.svg?inline";
import LegacyArrowRightSvg from "img/icons/LEGACY-arrow-right.svg?inline";
import LegacyHeartPressedSvg from "img/icons/LEGACY-heart-pressed.svg?inline";
import LegacyHeartUnpressedSvg from "img/icons/LEGACY-heart-unpressed.svg?inline";
import LocalShippingSharpSvg from "img/icons/local-shipping-sharp.svg?inline";
import LystAppIconSvg from "img/icons/lyst-app-icon.svg?inline";
import MinusSvg from "img/icons/minus.svg?inline";
import NotificationActiveSvg from "img/icons/notification-active.svg?inline";
import PadlockSvg from "img/icons/padlock.svg?inline";
import PlusThinSvg from "img/icons/plus-thin.svg?inline";
import PlusSvg from "img/icons/plus.svg?inline";
import PriceChangeSvg from "img/icons/price-change.svg?inline";
import PriceDropSvg from "img/icons/price-drop.svg?inline";
import PromoTagSvg from "img/icons/promo-tag.svg?inline";
import ReturnFilledSvg from "img/icons/return-filled.svg?inline";
import RoundCheckboxCheckedSvg from "img/icons/round-checkbox-checked.svg?inline";
import RoundCheckboxSvg from "img/icons/round-checkbox.svg?inline";
import RoundChevronSvg from "img/icons/round-chevron.svg?inline";
import RoundRadiobuttonCheckedSvg from "img/icons/round-radiobutton-checked.svg?inline";
import RoundRadiobuttonSvg from "img/icons/round-radiobutton.svg?inline";
import SearchEmoSvg from "img/icons/search-emo.svg?inline";
import SearchSvg from "img/icons/search.svg?inline";
import SearchesIconEmptySvg from "img/icons/searches-icon-empty.svg?inline";
import SearchesIconFilledSvg from "img/icons/searches-icon-filled.svg?inline";
import ShieldVerifiedSvg from "img/icons/shield-verified.svg?inline";
import ShippingFilledSvg from "img/icons/shipping-filled.svg?inline";
import ShoppingBasketSvg from "img/icons/shopping-basket.svg?inline";
import ShowOffSvg from "img/icons/show-off.svg?inline";
import ShowOnSvg from "img/icons/show-on.svg?inline";
import SmallArrowSvg from "img/icons/small-arrow.svg?inline";
import SquareChevronThinSvg from "img/icons/square-chevron-thin.svg?inline";
import SquareChevronSvg from "img/icons/square-chevron.svg?inline";
import SuccessCircleSvg from "img/icons/success-circle.svg?inline";
import SuccessFilledSvg from "img/icons/success-filled.svg?inline";
import TagFillSvg from "img/icons/tag-fill.svg?inline";
import TagOutlineSvg from "img/icons/tag-outline.svg?inline";
import TagSvg from "img/icons/tag.svg?inline";
import TapHandSvg from "img/icons/tap-hand.svg?inline";
import TickNewSvg from "img/icons/tick-new.svg?inline";
import TickSvg from "img/icons/tick.svg?inline";
import TimeSharpSvg from "img/icons/time-sharp.svg?inline";
import TruckSvg from "img/icons/truck.svg?inline";
import UserIconEmoSvg from "img/icons/user-icon-emo.svg?inline";
import UserIconSvg from "img/icons/user-icon.svg?inline";
import VerifiedSvg from "img/icons/verified.svg?inline";
import WarningIconSvg from "img/icons/warning-icon.svg?inline";
import WorldSvg from "img/icons/world.svg?inline";

import * as styles from "./svg-icon.css";

type SVGComponent = React.FC<React.SVGProps<SVGSVGElement> & { title?: string; titleId?: string }>;

const icons = {
    "account-icon": AccountIconSvg,
    "apple-icon": AppleIconSvg,
    "arrow-down": ArrowDownSvg,
    "arrow-emo": ArrowEmoSvg,
    "arrow-icon": ArrowIconSvg,
    "arrow-left": ArrowLeftSvg,
    "arrow-right": ArrowRightSvg,
    "basket-icon": BasketIconSvg,
    bell: BellSvg,
    "bell-empty": BellEmptySvg,
    "bell-nav": BellNavSvg,
    "bell-nav-filled": BellNavFilledSvg,
    calendar: CalendarSvg,
    chevron: ChevronSvg,
    "chevron-emo": ChevronEmoSvg,
    "chevron-medium": ChevronMediumSvg,
    "chevron-thin": ChevronThinSvg,
    clear: ClearSvg,
    "clear-filled": ClearFilledSvg,
    close: CloseSvg,
    "close-sharp": CloseSharpSvg,
    copy: CopySvg,
    cross: CrossSvg,
    "cross-thin": CrossThinSvg,
    "delivered-filled": DeliveredFilledSvg,
    "emo-basket": EmoBasketSvg,
    "emo-star": EmoStarSvg,
    "emo-tick": EmoTickSvg,
    error: ErrorSvg,
    "error-circle": ErrorCircleSvg,
    "error-filled": ErrorFilledSvg,
    expand: ExpandSvg,
    "expand-legacy": ExpandLegacySvg,
    "external-link": ExternalLinkSvg,
    facebook: FacebookSvg,
    "facebook-icon": FacebookIconSvg,
    filters: FiltersSvg,
    "google-icon": GoogleIconSvg,
    heart: HeartSvg,
    "heart-empty": HeartEmptySvg,
    "heart-broken": HeartBrokenSvg,
    "heart-icon-empty": HeartIconEmptySvg,
    "heart-icon-filled": HeartIconFilledSvg,
    "heart-icon-nav": HeartIconNavSvg,
    "heart-icon-nav-filled": HeartIconNavFilledSvg,
    "heart-pressed": HeartPressedSvg,
    "heart-unpressed": HeartUnpressedSvg,
    hyperlink: HyperlinkSvg,
    "icon-smiley": IconSmileySvg,
    "info-circle": InfoCircleSvg,
    "info-icon": InfoIconSvg,
    "LEGACY-arrow-right": LegacyArrowRightSvg,
    "LEGACY-heart-pressed": LegacyHeartPressedSvg,
    "LEGACY-heart-unpressed": LegacyHeartUnpressedSvg,
    "local-shipping-sharp": LocalShippingSharpSvg,
    "lyst-app-icon": LystAppIconSvg,
    minus: MinusSvg,
    "notification-active": NotificationActiveSvg,
    padlock: PadlockSvg,
    plus: PlusSvg,
    "plus-thin": PlusThinSvg,
    "price-change": PriceChangeSvg,
    "price-drop": PriceDropSvg,
    "promo-tag": PromoTagSvg,
    "return-filled": ReturnFilledSvg,
    "round-checkbox": RoundCheckboxSvg,
    "round-checkbox-checked": RoundCheckboxCheckedSvg,
    "round-chevron": RoundChevronSvg,
    "round-radiobutton": RoundRadiobuttonSvg,
    "round-radiobutton-checked": RoundRadiobuttonCheckedSvg,
    search: SearchSvg,
    "search-emo": SearchEmoSvg,
    "searches-icon-empty": SearchesIconEmptySvg,
    "searches-icon-filled": SearchesIconFilledSvg,
    "shield-verified": ShieldVerifiedSvg,
    "shipping-filled": ShippingFilledSvg,
    "shopping-basket": ShoppingBasketSvg,
    "show-off": ShowOffSvg,
    "show-on": ShowOnSvg,
    "small-arrow": SmallArrowSvg,
    "square-chevron": SquareChevronSvg,
    "square-chevron-thin": SquareChevronThinSvg,
    "success-circle": SuccessCircleSvg,
    "success-filled": SuccessFilledSvg,
    tag: TagSvg,
    "tag-fill": TagFillSvg,
    "tag-outline": TagOutlineSvg,
    "tap-hand": TapHandSvg,
    tick: TickSvg,
    "tick-new": TickNewSvg,
    "time-sharp": TimeSharpSvg,
    truck: TruckSvg,
    "user-icon": UserIconSvg,
    "user-icon-emo": UserIconEmoSvg,
    verified: VerifiedSvg,
    "warning-icon": WarningIconSvg,
    world: WorldSvg,
} satisfies Record<string, SVGComponent>;

export type SVGIconName = keyof typeof icons;

export interface SVGIconProps {
    name: SVGIconName;
    className?: string;
    overrideStyle?: boolean;
    title?: string;
    style?: React.CSSProperties;
    dataTestId?: string;
}

interface SVGIconRotateProps extends SVGIconProps {
    rotate?: number;
}

interface SVGIconFlipProps extends SVGIconProps {
    flip?: boolean;
}

export function SVGIcon({
    name,
    className,
    overrideStyle,
    title,
    ...props
}: SVGIconRotateProps | SVGIconFlipProps): React.ReactElement {
    let inlineStyles: React.CSSProperties = {};
    if ("rotate" in props) {
        inlineStyles["transform"] = `rotate(${props.rotate}deg)`;
    } else if ("flip" in props) {
        inlineStyles["transform"] = "rotateY(180deg)";
    }

    const Icon = icons[name] as SVGComponent;
    return (
        <Icon
            data-testid={props.dataTestId || "icon"}
            style={{ ...inlineStyles, ...props.style }}
            aria-hidden={title ? undefined : "true"}
            className={clsx(!overrideStyle && styles.icon, `svg-icon-${name}`, className)}
            title={title}
        />
    );
}

export default SVGIcon;
